import React, { useState, useEffect } from 'react';
import { Shield, ChevronDown, BookOpen, UserCog } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { Button } from '@/components/ui/button';

import { useTranslation } from 'react-i18next';

export const RolesDropdown = () => {
    const location = useLocation();
    const { t } = useTranslation();
    const isMainActive = location.pathname.startsWith('/admin/roles') || location.pathname.startsWith('/admin/permissions');
    const [isOpen, setIsOpen] = useState(isMainActive);

    const isActive = (path: string) => location.pathname === path;

    useEffect(() => {
        if (isMainActive) {
            setIsOpen(true);
        }
    }, [isMainActive]);

    return (
        <div className="space-y-1">
            <Button
                variant={isMainActive && !isOpen ? 'secondary' : 'ghost'}
                onClick={() => setIsOpen(!isOpen)}
                className={cn(
                    "w-full justify-between font-medium transition-all duration-200"
                )}
            >
                <div className="flex items-center">
                    <Shield className="mr-3 h-4 w-4" />
                    <span>{t('sidebar.roles_perms')}</span>
                </div>
                <div className={cn(
                    "p-1 rounded-md transition-colors",
                    isOpen ? "bg-muted" : "transparent"
                )}>
                    <ChevronDown className={cn(
                        "h-3.5 w-3.5 transition-transform duration-200",
                        isOpen && "rotate-180"
                    )} />
                </div>
            </Button>

            {isOpen && (
                <div className="mx-1 mt-1 rounded-lg border border-border/40 bg-muted/20 p-1 space-y-1 animate-in slide-in-from-top-1 duration-200">
                    <Link to="/admin/roles">
                        <Button
                            variant={isActive('/admin/roles') ? 'secondary' : 'ghost'}
                            className="w-full justify-start text-[13px] h-9 px-3 font-medium transition-colors"
                        >
                            <UserCog className="mr-3 h-4 w-4" />
                            {t('sidebar.manage_roles')}
                        </Button>
                    </Link>
                    <Link to="/admin/permissions">
                        <Button
                            variant={isActive('/admin/permissions') ? 'secondary' : 'ghost'}
                            className="w-full justify-start text-[13px] h-9 px-3 font-medium transition-colors"
                        >
                            <BookOpen className="mr-3 h-4 w-4" />
                            {t('sidebar.auth_matrix')}
                        </Button>
                    </Link>
                </div>
            )}
        </div>
    );
};
